import { IrveAnalysis, IrveFormBorne } from "@types"

/**
 * Permet de regrouper les bornes similaires
 * @param bornes bornes à regrouper
 */
export function groupSimilarBornes(
    bornes: {
        cos_phi: number
        puissanceactive_moyenne: number
        puissanceactive_nominale: number
    }[]
): IrveFormBorne[] {
    const groupedBornesMap: Map<string, IrveFormBorne> = new Map()
    // Regrouper les bornes similaires
    bornes.forEach((borne) => {
        const key = `${borne.cos_phi}-${borne.puissanceactive_moyenne}-${borne.puissanceactive_nominale}`
        if (groupedBornesMap.has(key)) {
            const existingBorne = groupedBornesMap.get(key)!
            existingBorne.quantity += 1
        } else {
            groupedBornesMap.set(key, {
                power: borne.puissanceactive_nominale,
                powerFactor: borne.cos_phi,
                powerMean: borne.puissanceactive_moyenne,
                quantity: 1,
            })
        }
    })
    // Retourner les bornes regroupées
    return Array.from(groupedBornesMap.values())
}

/**
 * Type des études IRVE (puissance résiduelle), tel que le service irve l'écrit
 * dans AnalyseV2 (`interfaces/api/main.py`, `type="tunnel_residual_power"`).
 */
export const TYPE_ANALYSE_IRVE = "tunnel_residual_power"

/**
 * Ne garde que les études IRVE (DEV-2311, F8). La route des études d'un
 * bâtiment sert toute la collection AnalyseV2, Optim TURPE V2 comprise : sans
 * ce filtre, la dernière étude du bâtiment, prise comme courante par la page,
 * pouvait être une étude Optim TURPE.
 */
export function analysesIrve(analyses: IrveAnalysis[]): IrveAnalysis[] {
    return analyses.filter((analyse) => analyse.type === TYPE_ANALYSE_IRVE)
}
